import * as api from '@api';
import * as constants from '@constants';
import { useAuth } from '@state/auth';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation } from '@/hooks/useApi';
import useToast from '@/hooks/useToast';

const SlcpFacilityRedirect = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const facilityId = queryParams.get('facid');
  const { toast } = useToast();
  const navigate = useNavigate();
  const me = useAuth(state => state.me);

  const { mutate: onProfilePatch } = useMutation(
    ({ forCompanyId, onBehalfOfCompanyId, dataPointName, value }) =>
      api.backend.patchTemplateAnswer(constants.PROFILE_TEMPLATES.OTHER_IDS, {
        forCompanyId,
        onBehalfOfCompanyId,
        answer: { [dataPointName]: { value } },
      }),
    {
      onSuccess: ({ status }) => {
        if (status >= 400) {
          return toast.error(
            'We encountered an error while saving your facility information.',
            {
              position: 'bottom-center',
            },
          );
        }
        toast.success('Your SLCP facility ID has been successfully saved!', {
          position: 'bottom-center',
        });
        navigate('/');
      },
      onError: error => {
        toast.error(
          error?.message ||
            'We encountered an unexpected error while saving your facility information.',
          {
            position: 'bottom-center',
          },
        );
      },
    },
  );

  useEffect(() => {
    if (!me) {
      navigate('/login');
      return;
    }
    if (facilityId) {
      onProfilePatch({
        forCompanyId: me.companyId,
        onBehalfOfCompanyId: me.companyId,
        dataPointName: 'slcp_facility_id',
        value: facilityId,
      });
    }
  }, [facilityId, me]);

  return (
    <section className='hero is-fullheight'>
      <div className='hero-body'>
        <div className='container tw:text-center'>
          <div className='columns is-tablet is-centered'>
            <div className='column is-one-third'>
              <img
                className='m-t-1'
                src={`${import.meta.env.VITE_CDN_URI}/static/dashboard-service/secondary-logo-black-v2.svg`}
                alt='Retraced logo'
                width='250'
              />
              <h1 className='title is-4'>Connecting SLCP Facility</h1>
              <p className='subtitle'>
                Please wait while we update your facility information and
                redirect you...
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SlcpFacilityRedirect;
